import FlashOnIcon from '@mui/icons-material/FlashOn'; // Fast implementation
import LayersIcon from '@mui/icons-material/Layers'; // Scalable training
import VerifiedIcon from '@mui/icons-material/Verified'; // Expert-designed content
import {
  Box,
  Card,
  CardContent,
  Container,
  Grid,
  Typography,
} from '@mui/material';
import { HeroDarkBgColor, HeroLightBgColor } from '../../HomeView/HomeView';
import { SectionTitleFontSize } from '../PurchaseTraining';

/**
 * A page that describes the benefits of purchasing the training
 */
const Benefits = () => {
  const benefits = [
    {
      title: 'Fast & Seamless Onboarding',
      description:
        'Get your organization up and running in minutes, with training that’s easy to access and complete.',
      icon: <FlashOnIcon sx={{ fontSize: 40, color: 'primary.main' }} />,
    },
    {
      title: 'Flexible, Scalable Training',
      description:
        'Assign required courses, provide optional training, and scale effortlessly as your team grows.',
      icon: <LayersIcon sx={{ fontSize: 40, color: 'primary.main' }} />,
    },
    {
      title: 'Designed by Industry Experts',
      description:
        'Developed by Jim Warwick, Ed. D., our training ensures your team is prepared for real-world situations.',
      icon: <VerifiedIcon sx={{ fontSize: 40, color: 'primary.main' }} />,
    },
  ];

  return (
    <Box
      sx={{
        py: 10,
        backgroundColor: (t) =>
          t.palette.mode == 'dark' ? HeroDarkBgColor : HeroLightBgColor,
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant="h4"
          component="h2"
          align="center"
          sx={{
            marginBottom: '2em',
            fontWeight: 500,
            fontSize: SectionTitleFontSize,
          }}
        >
          Why Choose Our Training?
        </Typography>
        <Grid container spacing={4} justifyContent="center">
          {benefits.map((benefit, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                sx={{
                  textAlign: 'center',
                  p: 2,
                  boxShadow: 3,
                  borderRadius: 2,
                  transition: 'transform 0.2s',
                  height: '100%',
                  '&:hover': { transform: 'translateY(-4px)' },
                }}
              >
                <CardContent>
                  {benefit.icon}
                  <Typography
                    variant="h6"
                    component="h3"
                    gutterBottom
                    sx={{ mt: 2 }}
                  >
                    {benefit.title}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    {benefit.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Benefits;
